"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { CONSENT_CHANGE_EVENT, CONSENT_KEY, GA_ID, refreshStoredConsent, trackPageView } from "@/lib/analytics";

/**
 * Consent-controlled GA4 bootstrap + SPA page views. The helper owns the one
 * loader and deterministic consent/config/event order across React remounts.
 *
 * Renders nothing. Inert when NEXT_PUBLIC_GA_MEASUREMENT_ID is unset (local dev,
 * verification builds) so no request ever leaves the page.
 */
export default function Analytics() {
    const pathname = usePathname();
    useEffect(() => {
        if (!GA_ID) return;
        const pageView = () => trackPageView(pathname);
        const storedChoiceChanged = (event: StorageEvent) => {
            if (event.key === CONSENT_KEY || event.key === null) refreshStoredConsent();
        };
        window.addEventListener(CONSENT_CHANGE_EVENT, pageView);
        window.addEventListener("storage", storedChoiceChanged);
        pageView();
        return () => {
            window.removeEventListener(CONSENT_CHANGE_EVENT, pageView);
            window.removeEventListener("storage", storedChoiceChanged);
        };
    }, [pathname]);

    return null;
}
